import { Component, inject, signal, OnInit } from '@angular/core';
import { UserLoginService } from '../../../service/user-login.service';
import { NotifyService } from '../../../service/notify.service';

@Component({
  selector: 'app-user-preferences-page',
  templateUrl: './user-preferences.component.html',
  styleUrls: ['./user-preferences.component.scss'],
  standalone: false,
})
export class UserPreferencesComponent implements OnInit {
  private userService = inject(UserLoginService);
  private notifyService = inject(NotifyService);

  public email = signal<string>('');
  public givenName = signal<string>('');
  public familyName = signal<string>('');
  public isExternalIdentity = signal<boolean>(false);

  public shouldReceiveTheftReportEmails = signal<boolean>(false);
  public shouldReceiveAccessRequests = signal<boolean>(false);
  public shouldReceiveMarketingEmails = signal<boolean>(false);

  ngOnInit() {
    this.userService.auth.user$.subscribe((claims) => {
      if (!claims) {
        return;
      }

      this.email.set(claims.email);

      const nameSplit = claims.name.split(' ');

      const profile = this.userService.currentProfile();
      this.shouldReceiveTheftReportEmails.set(profile.preferences.email_preferences?.receive_suspicious_incident_reports ?? true);
      this.shouldReceiveAccessRequests.set(profile.preferences.email_preferences?.receive_access_requests ?? true);
      this.shouldReceiveMarketingEmails.set(profile.preferences.email_preferences?.receive_marketing_emails ?? true);

      this.givenName.set(profile.preferences.first_name ?? claims.given_name ?? profile.name ?? nameSplit.shift());
      this.familyName.set(profile.preferences.last_name ?? claims.family_name ?? nameSplit.join(' '));
      this.isExternalIdentity.set(claims.sub.includes('google-oauth2'));
    });
  }

  save() {
    this.userService
      .updateMyProfile({
        first_name: this.givenName(),
        last_name: this.familyName(),
        email_preferences: {
          receive_suspicious_incident_reports: this.shouldReceiveTheftReportEmails(),
          receive_access_requests: this.shouldReceiveAccessRequests(),
          receive_marketing_emails: this.shouldReceiveMarketingEmails(),
        },
      })
      .subscribe(() => {
        this.notifyService.notify('Saved user preferences!');
      });
  }

  resetPassword() {
    this.userService.resetPassword(this.email()).subscribe(() => {
      this.notifyService.notify(`Password reset email sent to ${this.email()}!`);
    });
  }
}
